import { useEffect, useState } from "react";

import { i18n } from "../../../../../localization/i18n";

import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { Modal } from "../../../../../components/Modal";
import { OutlinedButton } from "../../../../../components/OutlinedButton";
import { OutlinedInput } from "../../../../../components/OutlinedInput";
import { OutlinedCheckbox } from "../../../../../components/OutlinedCheckbox";

import { IOrder } from "../../dtos";

import { RiCloseLine } from "react-icons/ri";

import {
  EditOrderUrgencyModalContainer,
  Header,
  Content,
  InputContainer,
  CheckboxContainer,
  Footer,
} from "./styles";
import { showToast } from "../../../../../components/CustomToast";
import api from "../../../../../services/api";

interface EditOrderUrgencyModalProps {
  open: boolean;
  order: IOrder;
  handleCloseModal: () => void;
  onOrderUpdated: () => Promise<void>;
}

export function EditOrderUrgencyModal({
  open,
  order,
  handleCloseModal,
  onOrderUpdated,
}: EditOrderUrgencyModalProps) {
  const [loading, setLoading] = useState(false);
  const [urgencyInfos, setUrgencyInfos] = useState({
    urgency_type: "",
    justify: "",
    priceDouble: false,
    total: 0,
  });

  async function handleUpdateOrderUrgency() {
    setLoading(true);

    try {
      const body = {
        total: urgencyInfos.total,
        urgency_type: urgencyInfos.urgency_type,
        urgency_reason: urgencyInfos.justify,
      };

      await api.put(`/orders/control/urgency/${order.id}`, body);
      await onOrderUpdated();

      handleCloseModal();
    } catch (error) {
      showToast({
        type: "error",
        message: "Ocorreu um erro ao atualizar a urgência do pedido",
      });
    } finally {
      setLoading(false);
    }
  }

  function changeUrgencyInfos(data: Partial<typeof urgencyInfos>) {
    setUrgencyInfos((prevState) => ({
      ...prevState,
      ...data,
    }));
  }

  useEffect(() => {
    setUrgencyInfos({
      urgency_type: order?.urgency_type,
      justify: order?.urgency_reason ?? "",
      priceDouble: order?.urgency_type === "requested" && !order.urgency_reason,
      total: Number(order.total),
    });
  }, [order, open]);

  return (
    <Modal open={open} modalWidth={480}>
      <EditOrderUrgencyModalContainer>
        <Header>
          <span className="title">Editar urgência</span>
          <RiCloseLine
            onClick={() => {
              handleCloseModal();
            }}
          />
        </Header>

        <Content>
          <RadioGroup
            value={urgencyInfos.urgency_type}
            onChange={(event) => {
              changeUrgencyInfos({ urgency_type: event.target.value });
            }}
          >
            <FormControlLabel
              value="normal"
              control={<Radio />}
              label="Normal"
            />
            <FormControlLabel
              value="requested"
              control={<Radio />}
              label="Solicitada"
            />
            <FormControlLabel
              value="approved"
              control={<Radio />}
              label="Aprovada"
            />
          </RadioGroup>

          <CheckboxContainer>
            <OutlinedCheckbox
              label="Preço dobrado"
              checked={urgencyInfos.priceDouble}
              handleChange={() => {
                if (
                  order.urgency_type === "requested" &&
                  !order.urgency_reason
                ) {
                  changeUrgencyInfos({
                    priceDouble: !urgencyInfos.priceDouble,
                    total: !urgencyInfos.priceDouble
                      ? Number(order.total)
                      : Number(order.total) / 2,
                  });

                  return;
                }

                changeUrgencyInfos({
                  priceDouble: !urgencyInfos.priceDouble,
                  total: !urgencyInfos.priceDouble
                    ? Number(order.total) * 2
                    : Number(order.total),
                });
              }}
            />
          </CheckboxContainer>

          <InputContainer>
            <OutlinedInput
              inputName="urgency_justify"
              label="Justificativa da urgência"
              textArea
              value={urgencyInfos.justify}
              handleChange={(event) => {
                changeUrgencyInfos({ justify: event });
              }}
            />

            <div className="total">
              <strong>{`${i18n.t("orders.confirmation.totalValue")}`}: </strong>
              <span>
                {urgencyInfos.total.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </span>
            </div>
          </InputContainer>
        </Content>

        <Footer>
          <OutlinedButton
            buttonColor="var(--finished)"
            text="Salvar alterações"
            onClick={handleUpdateOrderUrgency}
            loading={loading}
          />
        </Footer>
      </EditOrderUrgencyModalContainer>
    </Modal>
  );
}
